export const RANGE_LAST_30_DAYS = { type: 'Last 30 Days' };

export const RANGE_LAST_90_DAYS = { type: 'Last 90 Days' };
